const bankAccounts = [
  {
    id: 1,
    name: "Card",
    currentBalance: (1200).toFixed(2),
    currency: "$",
    color: "var(--primary-font)",
    expiration: "04/24",
    cardNum: "5453 0000 0012 3873",
  },
  {
    id: 2,
    name: "Savings",
    currentBalance: (10000).toFixed(2),
    currency: "$",
    color: "var(--default-card-color)",
    expiration: "07/26",
    cardNum: "5153 0240 0312 3172",
  },
];

export default bankAccounts;
